module.exports = (__webpack_require__(21655))(2495);